export const environment = {
  useEmulators: false,
  firebase: {
    projectId: 'centro-terapeutico-cubic-d3fb2',
    appId: '1:421235960175:web:e5da40e980c085be4aa09a',
    storageBucket: 'centro-terapeutico-cubic-d3fb2.appspot.com',
    locationId: 'europe-west',
    apiKey: 'AIzaSyAXScY_fpEvyxuMSqp85spdIokote7i3Kw',
    authDomain: 'centro-terapeutico-cubic-d3fb2.firebaseapp.com',
    messagingSenderId: '421235960175',
    measurementId: 'G-CGVSJYFKTE'
  },
  production: true,
  basePath: 'https://ctc-api-w6awm36qaq-ew.a.run.app'
};
